import React from "react";
import { useTranslation } from "react-i18next";
import "./Expert.css";

function Expert() {
  const { t } = useTranslation();
  return (
    <div className="expert">
      <h1>{t("expert.title")}</h1>
      <p className="expert-intro">
        {t("expert.intro")}
      </p>

      <section className="expert-section">
        <h2>{t("expert.satochipTitle")}</h2>
        <p>
          <a
            href="https://satochip.io/"
            target="_blank"
            rel="noopener noreferrer"
            className="satochip-link"
          >
            Satochip
          </a>{" "}
          {t("expert.satochipDesc1")}
        </p>
        <p>
          {t("expert.satochipDesc2")}
        </p>
      </section>

      <section className="expert-section">
        <h2>{t("expert.requirementsTitle")}</h2>
        <ul className="requirements-list">
          <li>
            <strong>{t("expert.javaTitle")}</strong> {t("expert.javaDesc")}
            <div className="code-block">
              <code>sudo apt install openjdk-11-jdk</code>
            </div>
          </li>
          <li>
            <strong>{t("expert.smartcardTitle")}</strong> J3R180
            <p>
              {t("expert.smartcardDesc")}
            </p>
          </li>
          <li>
            {t("expert.globalPlatformTitle")}
            <div className="code-block">
              <code>
                git clone git@github.com:martinpaljak/GlobalPlatformPro.git
              </code>
            </div>
          </li>
          <li>
            <strong>{t("expert.pcscTitle")}</strong> {t("expert.pcscDesc")}
            <ul>
              <li>{t("expert.pcscInstall")}</li>
              <div className="code-block">
                <code>sudo apt-get install pcscd</code>
              </div>
              <li>{t("expert.pcscStart")}</li>
              <div className="code-block">
                <code>sudo service pcscd start</code>
              </div>
            </ul>
          </li>
        </ul>
      </section>

      <section className="expert-section coming-soon">
        <h2>📝 {t("expert.buildTitle")}</h2>
        <p>
          {t("expert.buildDesc")}
        </p>
        <p className="coming-soon-note">
          {t("expert.buildNote")}
        </p>
      </section>

      <section className="expert-section">
        <h2>{t("expert.nextStepsTitle")}</h2>
        <ol className="steps-list">
          <li>{t("expert.nextStep1")}</li>
          <li>{t("expert.nextStep2")}</li>
          <li>{t("expert.nextStep3")}</li>
          <li>{t("expert.nextStep4")}</li>
          <li>{t("expert.nextStep5")}</li>
          <li>{t("expert.nextStep6")}</li>
        </ol>
      </section>
    </div>
  );
}

export default Expert;

